import formatName, { formatNameWithParts } from './format-name';
export default function primaryName(person, {
  isJP
}) {
  return formatName(person, (first, last) => {
    if (isJP) {
      return last;
    } else {
      return first;
    }
  });
}
export function primaryNameWithParts(nullableFirst, nullableLast, {
  isJP
}) {
  return formatNameWithParts(nullableFirst, nullableLast, (first, last) => {
    if (isJP) {
      return last;
    } else {
      return first;
    }
  });
}